export default {
  computed: {
    productCategory() {
      const productCategory = this.$store.getters.VIEW_PRODUCT;

      if (productCategory.sets) {
        productCategory.minPrice = this._.minBy(productCategory.sets,
            'price_gross').price_gross;
      } else {
        /*const priceMapper = item => parseFloat(item.price);

        const prices = productCategory.items.reduce(
            (prevProduct, nextProduct) => prevProduct.variants.map(priceMapper).
                concat(nextProduct.variants.map(priceMapper)),
        );

        productCategory.minPrice = typeof prices.length !== 'undefined'
            ? Math.min(...prices)
            : parseFloat(
                this._.minBy(this._.first(productCategory.items).variants,
                    'price').price);*/

        productCategory.minPrice = parseFloat(
            this._.minBy(this._.first(productCategory.items).variants,
                'price').price);
      }

      return productCategory;
    },
  },
  methods: {
    next() {
      if (this.productCategory.sets) {
        this.selectSets(this.productCategory);
      } else {
        this.selectProductCategory(this.productCategory);
      }
    },
  },
};
